import React, { Fragment, useEffect, useState } from "react";
import { Box, Button, Dialog, Tab, TableContainer } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import "./TargetDetailedView.scss";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { getTargetService } from "../../services/targetService";
import { CATEGORY_CODE, TARGET_TYPES } from "../../constants/enums";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import EmissionDetailedViewDialog from "./EmissionDetailedViewDialog";
import CategoryDetailedViewDialog from "./CategoryDetailedViewDialog";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import FileAttachmentsDetails from "../common/FileAttachmentsDetails";
import CancelIcon from "@mui/icons-material/Cancel";
import { emissionAvailableCategoriesService } from "../../services/emissionService";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { checkPermissions } from "../../helper";
// import TargetVersionHistory from "./TargetVersionHistory";
import { getActivityAuditList } from "../../services/auditService";

const TargetDetailedView = (props: any) => {
  const { t, i18n } = useTranslation();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const {
    bunitData,
    onClose,
    controller,
    total_count,
    currentIndex,
    navigateNext,
    baseLineValues,
    setBaseLineValues,
    mostRecentYearValues,
    setMostRecentYearValues,
    targetYearValues,
    setTargetYearValues,
    netZeroValues,
    setNetZeroValues,
  } = props;

  const { business_unit: unitId, name: bunit_name } = bunitData;
  const navigate = useNavigate();
  const cellColumns =
    baseLineValues[0]?.target_coverage ===
    "Separate Targets for all 23 categories"
      ? ["Baseline year", "", "", ""]
      : ["Baseline year", "Emissions(tCO2e)", "", "Comments"];
  const cellColumnsRecentYear = [
    "Most Recent year",
    "Emissions(tCO2e)",
    "",
    "Comments",
  ];
  const cellColumnsTargetYear =
    baseLineValues[0]?.target_coverage ===
    "Separate Targets for all 23 categories"
      ? ["Target year"]
      : [
          "Target year",
          "Emissions(tCO2e)",
          "%SBT reduction",
          "",
          "Comments",
          "",
        ];
  const cellColumnsNetZeroYear = [
    "NetZero year",
    "Emissions(tCO2e)",
    "%SBT reduction",
    "",
    "Comments",
    "",
  ];

  const [versionHistoryData, setVersionHistoryData] = useState([] as any[]);
  const [attachmentsData, setAttachmentsData] = useState<any>({
    attachments: [],
  });

  const { page, limit } = controller;
  let index = limit * page + currentIndex;
  const openEdit = () => {
    navigate("/target/" + bunitData.id, {
      state: {
        baseLineValues: baseLineValues,
        mostRecentYearValues: mostRecentYearValues,
        targetYearValues: targetYearValues,
        netZeroValues: netZeroValues,
        bunit_name: bunit_name,
        error: { metricsValid: true, targetValid: true },
      },
    });
  };

  const onNavigateNext = (increment: number) => {
    if (increment > 0 && currentIndex === limit - 1) {
      navigateNext(increment, 1);
    } else if (increment < 0 && currentIndex === 0) {
      navigateNext(increment, -1);
    } else {
      navigateNext(increment, 0);
    }
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [openCategoryDialog, setOpenCategoryDialog] = useState(false);
  const [emissionData, setEmissionData] = useState([]);
  const [targetScope, setTargetScope] = useState(0);
  const [targetType, setTargetType] = useState("");
  const [emissionYear, setEmissionYear] = useState(0);
  const [currentTab, setCurrentTab] = useState("1");
  const [showMetrics, setShowMetrics] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [scopeToDisplay, setScopeToDisplay] = useState<number>(0);
  const [categoryTargetType, setCategoryTargetType] = useState<string>("");

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setOpenCategoryDialog(false);
  };

  const handleTableCellClick = (attachments: any) => {
    setShowFileUpload(true);
    setAttachmentsData({ attachments: [...attachments] });
  };
  const handleClose = () => {
    setShowFileUpload(false);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
    newValue === "1" ? setShowMetrics(false) : setShowMetrics(true);
  };

  const handleOpenCategoryDialog = (scope: number, type: string) => {
    setScopeToDisplay(scope);
    setCategoryTargetType(type);
    setOpenCategoryDialog(true);
  };

  useEffect(() => {
    let ids: string[] = [];
    getTargetService(unitId)
      .then((res) => {
        const targetValues = res.data;
        const baseValues = targetValues.filter(
          (each: any) => each.target_type === TARGET_TYPES.BASELINE
        );
        baseValues.forEach((each: any) => {
          ids.push(`'${each.target_code}'`);
        });
        const idsString = ids.join(",");
        const sortedBaseValues = baseValues.sort(
          (a: { target_scope: number }, b: { target_scope: number }) =>
            a.target_scope - b.target_scope
        );
        const mostRecent = targetValues.filter(
          (each: any) => each.target_type === TARGET_TYPES.MOST_RECENT
        );
        const targetYear = targetValues.filter(
          (each: any) => each.target_type === TARGET_TYPES.TARGET
        );
        const NetZero = targetValues.filter(
          (each: any) => each.target_type === TARGET_TYPES.NET_ZERO
        );
        targetYear.forEach((each: any) => {
          each.metrics.sort((a: any, b: any) => {
            return a.id - b.id;
          });
        });
        setBaseLineValues(sortedBaseValues);
        setMostRecentYearValues(mostRecent);
        setTargetYearValues(targetYear);
        setNetZeroValues(NetZero);

        const reqObj = {
          controller: controller,
          bunitId: bunitData.id,
          recordCode: idsString,
        };
        return getActivityAuditList(reqObj);
      })
      .then((res: any) => {
        let recentActivityList = res.data.activityAudits;
        setVersionHistoryData(recentActivityList);
        console.log(recentActivityList, "list");

        let auditCount = res.data.total_count;
        // setAuditCount(auditCount);
        // setRecentActivityList(recentActivityList);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bunitData, controller]);

  type Category = {
    code: string;
    name: string;
    id: number;
  };

  const [categoryList, setCategoryList] = useState<Category[]>([]);

  useEffect(() => {
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id;
    emissionAvailableCategoriesService(company, true)
      .then((res) => {
        let catList: [] = res.data;
        catList.sort((a: any, b: any) => a.code.localeCompare(b.code));
        setCategoryList([...catList]);
      })
      .catch((err) => {
        console.log("Error:", err?.response?.data?.message);
      });
  }, []);

  const categories = categoryList.filter((category: any) => {
    return baseLineValues.some((baseline: { emissions: any[] }) =>
      baseline.emissions.some(
        (emission: { category: number; is_included: boolean }) =>
          emission.category === category.id && emission.is_included
      )
    );
  });

  const renderBaselineTable = (count: number) => {
    return (
      <>
        {[...Array(count)].map((_, rowIdx) => {
          const relevantBaseline = baseLineValues.find(
            (baseline: { rowIdx: number }) => baseline.rowIdx === rowIdx
          );

          return (
            <React.Fragment key={rowIdx}>
              <TableHead className="pw-activity-table-head">
                <TableRow>
                  {cellColumns.map((eachCell: any, index: number) => {
                    const displayContent = () => {
                      if (
                        baseLineValues[0]?.target_coverage ===
                        "Common Target for total Scope 1, 2 & 3 emissions"
                      ) {
                        if (index === 0) {
                          return eachCell;
                        }
                      } else if (
                        baseLineValues[0]?.target_coverage ===
                        "Common Target for Scope 1 & 2; Separate Target for Scope 3"
                      ) {
                        if (index === 0) {
                          return rowIdx === 0
                            ? "Baseline year Scope 1 & 2"
                            : "Baseline year Scope 3";
                        }
                      } else {
                        if (index === 0) {
                          return rowIdx === 0
                            ? "Baseline year Scope 1"
                            : rowIdx === 1
                            ? "Baseline year Scope 2"
                            : "Baseline year Scope 3";
                        }
                      }
                      return eachCell;
                    };
                    return (
                      <TableCell
                        key={index}
                        className={`pw-activity-list ${
                          index === 0
                            ? "w-[284px]"
                            : index === 1
                            ? "w-[194px]"
                            : index === 2
                            ? "w-[36px]"
                            : "w-[203px]"
                        }`}
                        style={{ borderRight: "10px black" }}
                        align={index === 1 ? "center" : "left"}
                      >
                        {t(displayContent())}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* {targetState.targets
                    .filter((target: any) => target.type ===  TARGET_TYPES.BASELINE)
                    .map((relevantBaseline: any , index: number) => ( */}
                {baseLineValues[0]?.target_coverage ===
                "Separate Targets for all 23 categories" ? (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <div className="flex flex-row justify-between">
                        <button
                          className=" text-info-500  cursor-pointer"
                          onClick={() =>
                            handleOpenCategoryDialog(
                              rowIdx + 1,
                              TARGET_TYPES.BASELINE
                            )
                          }
                        >
                          View details for scope {rowIdx + 1} categories
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    <TableRow key={rowIdx}>
                      <TableCell>
                        <div className="flex flex-row justify-between">
                          {baseLineValues[rowIdx]?.target_year}
                          <div>
                            <button
                              className="text-info-500"
                              onClick={() => {
                                handleOpenDialog();
                                setEmissionYear(
                                  baseLineValues[rowIdx]?.target_year
                                );
                                setEmissionData(
                                  baseLineValues[rowIdx]?.emissions
                                );
                                setTargetType(TARGET_TYPES.BASELINE);
                                setTargetScope(
                                  baseLineValues[rowIdx]?.target_scope
                                );
                              }}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        {baseLineValues[rowIdx]?.target_value}
                      </TableCell>
                      <TableCell
                        className={`${
                          baseLineValues[rowIdx]?.target_year
                            ? "cursor-pointer"
                            : "cursor-not-allowed"
                        }`}
                      >
                        <img
                          className="ml-3.5"
                          src="assets/icons/FileUpload.svg"
                          onClick={
                            baseLineValues[rowIdx]?.target_attachments
                              ? () =>
                                  handleTableCellClick(
                                    baseLineValues[rowIdx]?.target_attachments
                                      .files || []
                                  )
                              : undefined
                          }
                          alt="Upload"
                        />
                        {baseLineValues[rowIdx]?.target_attachments &&
                        baseLineValues[rowIdx]?.target_attachments?.files
                          ?.length > 0 ? (
                          <sup className=" text-xs bg-primary badge">
                            {
                              baseLineValues[rowIdx].target_attachments?.files
                                ?.length
                            }
                          </sup>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell>
                        {baseLineValues[rowIdx]?.target_comments}
                      </TableCell>
                    </TableRow>
                  </>
                )}

                {/* ))} */}
              </TableBody>
            </React.Fragment>
          );
        })}
      </>
    );
  };

  const renderTargetTable = (count: number) => {
    return (
      <>
        {[...Array(count)].map((_, rowIdx) => {
          const isLastRow = rowIdx === count - 1;
          // const targetYrs = targetYearValues.filter(
          //   (eachTarget: { target_scope: number }) => eachTarget.target_scope === rowIdx
          // );
          const targetYrs = targetYearValues.filter(
            (eachTarget: { target_scope: number; target_coverage: string }) =>
              eachTarget.target_scope === rowIdx + 1 ||
              (eachTarget.target_coverage ===
                "Common Target for total Scope 1, 2 & 3 emissions" &&
                rowIdx === 0) ||
              (eachTarget.target_coverage ===
                "Common Target for Scope 1 & 2; Separate Target for Scope 3" &&
                rowIdx === 0 &&
                eachTarget.target_scope === null) ||
              (eachTarget.target_coverage ===
                "Common Target for Scope 1 & 2; Separate Target for Scope 3" &&
                eachTarget.target_scope === rowIdx + 2) ||
              (rowIdx === 0 &&
                eachTarget.target_coverage === null &&
                eachTarget.target_scope === null)
          );

          return (
            <div
              key={rowIdx}
              className={`flex flex-col ${
                isLastRow ? "" : "pb-10 bg-neutral-100"
              }`}
            >
              <Card>
                <Table size="small" className="pw-activity-table">
                  <TableHead className="pw-activity-table-head">
                    <TableRow>
                      {cellColumnsTargetYear.map((eachCell, index) => {
                        const displayContent = () => {
                          if (
                            baseLineValues[0]?.target_coverage ===
                            "Common Target for total Scope 1, 2 & 3 emissions"
                          ) {
                            if (index === 0) {
                              return eachCell;
                            }
                          } else if (
                            baseLineValues[0]?.target_coverage ===
                            "Common Target for Scope 1 & 2; Separate Target for Scope 3"
                          ) {
                            if (index === 0) {
                              return rowIdx === 0
                                ? "Target year Scope 1 & 2"
                                : "Target year Scope 3";
                            }
                          } else {
                            if (index === 0) {
                              return rowIdx === 0
                                ? "Target year Scope 1"
                                : rowIdx === 1
                                ? "Target year Scope 2"
                                : "Target year Scope 3";
                            }
                          }
                          return eachCell;
                        };
                        return (
                          <TableCell
                            key={index}
                            className={`pw-activity-list ${
                              index === 0
                                ? "w-44"
                                : index === 1
                                ? "w-32 bg-total-row"
                                : index === 2
                                ? "w-40 bg-total-row"
                                : index === 3
                                ? "w-12"
                                : index === 4
                                ? "w-52"
                                : "w-20"
                            }`}
                            align={
                              index === 1 || index === 2 ? "center" : "left"
                            }
                          >
                            {t(displayContent())}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {baseLineValues[0]?.target_coverage ===
                    "Separate Targets for all 23 categories" ? (
                      <TableRow>
                        <TableCell colSpan={6}>
                          <div className="flex flex-row justify-between">
                            <button
                              className=" text-info-500  cursor-pointer"
                              onClick={() =>
                                handleOpenCategoryDialog(
                                  rowIdx + 1,
                                  TARGET_TYPES.TARGET
                                )
                              }
                            >
                              View details for scope {rowIdx + 1} categories
                            </button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <>
                        {targetYrs?.length
                          ? targetYrs.map((eachTarget: any) => (
                              <TableRow>
                                <TableCell>
                                  <div className="flex flex-row justify-between">
                                    {eachTarget?.target_year}
                                    <div className=" ml-2">
                                      <button
                                        className="text-info-500"
                                        onClick={() => {
                                          handleOpenDialog();
                                          setEmissionYear(
                                            eachTarget?.target_year
                                          );
                                          setEmissionData(
                                            eachTarget?.emissions
                                          );
                                          setTargetType(TARGET_TYPES.TARGET);
                                          setTargetScope(
                                            eachTarget?.target_scope
                                          );
                                        }}
                                      >
                                        View Details
                                      </button>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align="right">
                                  {eachTarget.target_value}
                                </TableCell>
                                <TableCell align="right">
                                  {eachTarget.target_reduction_percentage}
                                </TableCell>
                                <TableCell className="cursor-pointer">
                                  <img
                                    className="ml-2.5"
                                    src="assets/icons/FileUpload.svg"
                                    onClick={
                                      eachTarget?.target_attachments
                                        ? () =>
                                            handleTableCellClick(
                                              eachTarget?.target_attachments
                                                .files || []
                                            )
                                        : undefined
                                    }
                                    alt="Upload"
                                  />
                                  {eachTarget?.target_attachments?.files
                                    ?.length > 0 ? (
                                    <sup className=" text-xs bg-primary badge">
                                      {
                                        eachTarget?.target_attachments?.files
                                          ?.length
                                      }
                                    </sup>
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                                <TableCell>
                                  {eachTarget?.target_comments}
                                </TableCell>
                                <TableCell className="cursor-pointer">
                                  <div className="flex flex-row justify-evenly text-s">
                                    {eachTarget?.target_sbti_aligned ? (
                                      <img src="assets/icons/successAlert.svg" />
                                    ) : (
                                      <img src="assets/icons/infoAlert.svg" />
                                    )}{" "}
                                    {eachTarget?.target_alignment}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          : ""}
                      </>
                    )}
                  </TableBody>
                </Table>
              </Card>
            </div>
          );
        })}
      </>
    );
  };

  const metricsInverseAttributes: any = {
    ACTIVE_EMPLOYEES: "Active employees",
    GROSS_FLOOR_AREA: "Gross floor area",
    ANNUAL_REVENUE: "Annual revenue",
    ECONOMIC_INTENSITY: "Economic intensity",
    TARGET_NO_OF_UNITS: "Target no. of units",
  };

  type CurrentCategoryIdx = {
    [type: string]: {
      [rowIdx: number]: number;
    };
  };
  const [currentCategoryIdx, setCurrentCategoryIdx] =
    useState<CurrentCategoryIdx>({
      BASELINE: { 0: 0, 1: 0, 2: 0 },
      TARGET: { 0: 0, 1: 0, 2: 0 },
    });

  type FilteredCategoriesByRow = {
    [type: string]: {
      [rowIdx: number]: any[];
    };
  };

  const [filteredCategoriesByRow, setFilteredCategoriesByRow] =
    useState<FilteredCategoriesByRow>({
      BASELINE: {},
      TARGET: {},
    });

  const shouldDisplayCategory = (code: CATEGORY_CODE, scope: number) => {
    if (scope === 1) {
      return (
        code >= CATEGORY_CODE.CATEGORY_1_1 && code < CATEGORY_CODE.CATEGORY_2_1
      );
    } else if (scope === 2) {
      return (
        code >= CATEGORY_CODE.CATEGORY_2_1 && code < CATEGORY_CODE.CATEGORY_3_1
      );
    } else if (scope === 3) {
      return code >= CATEGORY_CODE.CATEGORY_3_1;
    }
  };

  const handleNextClick = (rowIdx: number, type: string) => {
    setCurrentCategoryIdx((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [rowIdx]: (prevState[type][rowIdx] ?? 0) + 1,
      },
    }));
  };

  const handlePrevClick = (rowIdx: number, type: string) => {
    setCurrentCategoryIdx((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [rowIdx]: (prevState[type][rowIdx] ?? 0) - 1,
      },
    }));
  };

  const renderBaselineMetricTable = (count: number) => {
    const displayContent = (rowIdx: number) => {
      if (
        baseLineValues[0]?.target_coverage ===
        "Common Target for total Scope 1, 2 & 3 emissions"
      ) {
        return "Baseline Year";
      } else if (
        baseLineValues[0]?.target_coverage ===
        "Common Target for Scope 1 & 2; Separate Target for Scope 3"
      ) {
        return rowIdx === 0
          ? "Baseline year Scope 1 & 2"
          : "Baseline year Scope 3";
      } else {
        return rowIdx === 0
          ? "Baseline year Scope 1"
          : rowIdx === 1
          ? "Baseline year Scope 2"
          : "Baseline year Scope 3";
      }
    };
    return (
      <>
        {[...Array(count)].map((_, rowIdx) => {
          filteredCategoriesByRow[TARGET_TYPES.BASELINE][rowIdx] =
            categories.filter((eachCategory: any) =>
              shouldDisplayCategory(eachCategory.code, rowIdx + 1)
            );
          const currentCategory =
            baseLineValues[0].target_coverage ===
            "Separate Targets for all 23 categories"
              ? filteredCategoriesByRow[TARGET_TYPES.BASELINE]?.[rowIdx]?.[
                  currentCategoryIdx[TARGET_TYPES.BASELINE]?.[rowIdx]
                ] ?? -1
              : -1;

          const baselines = baseLineValues.reduce(
            (accumulatedEmissions: any[], baseline: any) => {
              const matchingEmissions = baseline.emissions
                .filter(
                  (emission: any) => emission.category === currentCategory?.id
                )
                .map(() => ({
                  ...baseline,
                }));

              return accumulatedEmissions.concat(matchingEmissions);
            },
            []
          );

          const metrics =
            baseLineValues[0].target_coverage ===
            "Separate Targets for all 23 categories"
              ? baselines[0]?.metrics
              : baseLineValues[rowIdx]?.metrics;

          return (
            <React.Fragment key={rowIdx}>
              <Table size="small" className="pw-activity-table">
                <TableHead className="pw-activity-table-head">
                  <TableRow>
                    <TableCell className="pw-activity-list w-[205px]">
                      {t(displayContent(rowIdx))}
                    </TableCell>
                    {metrics?.length
                      ? metrics.map((eachMetric: any, index: number) => (
                          <TableCell key={index} align="left">
                            <div className="flex flex-col">
                              <span>
                                {metricsInverseAttributes[eachMetric?.type] ||
                                  eachMetric?.type}
                              </span>
                              <span>{eachMetric?.uom_name}</span>
                            </div>
                          </TableCell>
                        ))
                      : ""}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {baseLineValues[0].target_coverage ===
                    "Separate Targets for all 23 categories" &&
                  baselines.length ? (
                    <TableRow>
                      <TableCell colSpan={3}>
                        {currentCategory?.code} {currentCategory?.name}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {baseLineValues[0].target_coverage ===
                    "Separate Targets for all 23 categories" &&
                  baselines.length === 0 ? (
                    <TableCell>Baseline year not defined</TableCell>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell rowSpan={2} style={{ border: "none" }}>
                          <TableRow>
                            <TableCell rowSpan={2} className="w-[58px]">
                              {baseLineValues[0].target_coverage ===
                              "Separate Targets for all 23 categories"
                                ? baselines[0]?.target_year
                                : baseLineValues[rowIdx]?.target_year}
                            </TableCell>
                            <TableCell>Activity Output</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Intensity</TableCell>
                          </TableRow>
                        </TableCell>
                        {metrics?.length
                          ? metrics.map((eachMetric: any) => (
                              <TableCell key={eachMetric.type} align="left">
                                {eachMetric.value}
                              </TableCell>
                            ))
                          : null}
                      </TableRow>
                    </>
                  )}

                  <TableRow>
                    {metrics?.length
                      ? metrics.map((eachMetric: any) => (
                          <TableCell key={eachMetric.type} align="left">
                            {eachMetric.intensity}
                          </TableCell>
                        ))
                      : null}
                  </TableRow>

                  {baseLineValues[0].target_coverage ===
                    "Separate Targets for all 23 categories" &&
                  baselines.length ? (
                    <TableRow className="navigation-row">
                      <TableCell
                        colSpan={6}
                        className="pw-activity-list bg-neutral-50 pw-navigation-container"
                      >
                        <div className="pw-navigation-content">
                          {currentCategoryIdx[TARGET_TYPES.BASELINE]?.[rowIdx] >
                            0 && (
                            <div className="flex flex-row gap-2">
                              <div className="text-primary">
                                Previous Category
                              </div>
                              <div
                                onClick={() =>
                                  handlePrevClick(rowIdx, TARGET_TYPES.BASELINE)
                                }
                                className="pw-navigate-next pw-padding-5"
                              >
                                <ArrowLeft />
                              </div>
                            </div>
                          )}
                          {currentCategoryIdx[TARGET_TYPES.BASELINE]?.[rowIdx] <
                            filteredCategoriesByRow[TARGET_TYPES.BASELINE][
                              rowIdx
                            ].length -
                              1 && (
                            <div className="flex flex-row ml-auto gap-2">
                              <div className="text-primary">Next Category</div>
                              <div
                                onClick={() =>
                                  handleNextClick(rowIdx, TARGET_TYPES.BASELINE)
                                }
                                className="pw-navigate-next pw-padding-5"
                              >
                                <ArrowRight />
                              </div>
                            </div>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            </React.Fragment>
          );
        })}
      </>
    );
  };

  const renderTargetMetricTable = (count: number) => {
    const displayContent = (rowIdx: number) => {
      if (
        baseLineValues[0]?.target_coverage ===
        "Common Target for total Scope 1, 2 & 3 emissions"
      ) {
        return "Target Year";
      } else if (
        baseLineValues[0]?.target_coverage ===
        "Common Target for Scope 1 & 2; Separate Target for Scope 3"
      ) {
        return rowIdx === 0 ? "Target year Scope 1 & 2" : "Target year Scope 3";
      } else {
        return rowIdx === 0
          ? "Target year Scope 1"
          : rowIdx === 1
          ? "Target year Scope 2"
          : "Target year Scope 3";
      }
    };
    return (
      <>
        {[...Array(count)].map((_, rowIdx) => {
          const isLastRow = rowIdx === count - 1;

          filteredCategoriesByRow[TARGET_TYPES.TARGET][rowIdx] =
            categories.filter((eachCategory: any) =>
              shouldDisplayCategory(eachCategory.code, rowIdx + 1)
            );

          const currentCategory =
            baseLineValues[0].target_coverage ===
            "Separate Targets for all 23 categories"
              ? filteredCategoriesByRow[TARGET_TYPES.TARGET]?.[rowIdx]?.[
                  currentCategoryIdx[TARGET_TYPES.TARGET]?.[rowIdx]
                ] ?? -1
              : -1;

          const targetYrs =
            baseLineValues[0].target_coverage !==
            "Separate Targets for all 23 categories"
              ? targetYearValues.filter(
                  (eachTarget: {
                    target_scope: number;
                    target_coverage: string;
                  }) =>
                    eachTarget.target_scope === rowIdx + 1 ||
                    (eachTarget.target_coverage ===
                      "Common Target for total Scope 1, 2 & 3 emissions" &&
                      rowIdx === 0) ||
                    (eachTarget.target_coverage ===
                      "Common Target for Scope 1 & 2; Separate Target for Scope 3" &&
                      rowIdx === 0 &&
                      eachTarget.target_scope === null) ||
                    (eachTarget.target_coverage ===
                      "Common Target for Scope 1 & 2; Separate Target for Scope 3" &&
                      eachTarget.target_scope === rowIdx + 2) ||
                    (rowIdx === 0 &&
                      eachTarget.target_coverage === null &&
                      eachTarget.target_scope === null)
                )
              : targetYearValues.reduce(
                  (accumulatedEmissions: any[], target: any) => {
                    const matchingEmissions = target.emissions
                      .filter(
                        (emission: any) =>
                          emission.category === currentCategory?.id
                      )
                      .map(() => ({
                        ...target,
                      }));

                    return accumulatedEmissions.concat(matchingEmissions);
                  },
                  []
                );

          return (
            <div
              key={rowIdx}
              className={`flex flex-col ${
                isLastRow ? "" : "pb-10 bg-neutral-100"
              }`}
            >
              <Card>
                <Table size="small" className="pw-activity-table">
                  <TableHead className="pw-activity-table-head">
                    <TableRow>
                      <TableCell className="pw-activity-list w-[205px]">
                        {t("Projection for ") + displayContent(rowIdx)}
                      </TableCell>
                      {targetYrs.length > 0 && targetYrs[0]?.metrics?.length ? (
                        targetYrs[0].metrics.map(
                          (eachMetric: any, index: number) => (
                            <TableCell key={index} align="left">
                              <div className="flex flex-col">
                                <span>
                                  {eachMetric?.type === "ECONOMIC_INTENSITY"
                                    ? "Economic intensity ratio"
                                    : `${
                                        metricsInverseAttributes[
                                          eachMetric?.type
                                        ] || eachMetric?.type
                                      } intensity ratio`}
                                </span>
                                <span>{eachMetric?.uom_name}</span>
                              </div>
                            </TableCell>
                          )
                        )
                      ) : (
                        <TableCell></TableCell>
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {baseLineValues[0].target_coverage ===
                      "Separate Targets for all 23 categories" &&
                    targetYrs.length ? (
                      <TableRow>
                        <TableCell colSpan={3}>
                          {currentCategory?.code} {currentCategory?.name}
                        </TableCell>
                      </TableRow>
                    ) : null}
                    {targetYrs.length ? (
                      targetYrs.map((eachTarget: any) => {
                        const metrics = eachTarget?.metrics;
                        return (
                          <React.Fragment key={eachTarget?.target_year}>
                            <TableRow>
                              <TableCell rowSpan={3} style={{ border: "none" }}>
                                <TableRow>
                                  <TableCell rowSpan={3} className="w-[58px]">
                                    {eachTarget?.target_year}
                                  </TableCell>
                                  <TableCell>Activity Output</TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>% reduction</TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>Intensity</TableCell>
                                </TableRow>
                              </TableCell>
                              {metrics?.length ? (
                                metrics.map((eachMetric: any) => (
                                  <TableCell key={eachMetric.type} align="left">
                                    {eachMetric.value}
                                  </TableCell>
                                ))
                              ) : (
                                <TableCell></TableCell>
                              )}
                            </TableRow>

                            <TableRow>
                              {metrics?.length ? (
                                metrics.map((eachMetric: any) => (
                                  <TableCell key={eachMetric.type} align="left">
                                    {eachMetric.percent}
                                  </TableCell>
                                ))
                              ) : (
                                <TableCell></TableCell>
                              )}
                            </TableRow>

                            <TableRow>
                              {metrics?.length ? (
                                metrics.map((eachMetric: any) => (
                                  <TableCell key={eachMetric.type} align="left">
                                    {eachMetric.intensity}
                                  </TableCell>
                                ))
                              ) : (
                                <TableCell></TableCell>
                              )}
                            </TableRow>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <TableCell>Target year not defined</TableCell>
                    )}
                    {baseLineValues[0].target_coverage ===
                      "Separate Targets for all 23 categories" &&
                    targetYrs.length ? (
                      <TableRow className="navigation-row">
                        <TableCell
                          colSpan={6}
                          className="pw-activity-list bg-neutral-50 pw-navigation-container"
                        >
                          <div className="pw-navigation-content">
                            {currentCategoryIdx[TARGET_TYPES.TARGET]?.[rowIdx] >
                              0 && (
                              <div className="flex flex-row gap-2">
                                <div className="text-primary">
                                  Previous Category
                                </div>
                                <div
                                  onClick={() =>
                                    handlePrevClick(rowIdx, TARGET_TYPES.TARGET)
                                  }
                                  className="pw-navigate-next pw-padding-5"
                                >
                                  <ArrowLeft />
                                </div>
                              </div>
                            )}
                            {currentCategoryIdx[TARGET_TYPES.TARGET]?.[rowIdx] <
                              filteredCategoriesByRow[TARGET_TYPES.TARGET][
                                rowIdx
                              ].length -
                                1 && (
                              <div className="flex flex-row ml-auto gap-2">
                                <div className="text-primary">
                                  Next Category
                                </div>
                                <div
                                  onClick={() =>
                                    handleNextClick(rowIdx, TARGET_TYPES.TARGET)
                                  }
                                  className="pw-navigate-next pw-padding-5"
                                >
                                  <ArrowRight />
                                </div>
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </Card>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div className="flex w-70 flex-col px-4 grow pw-detailed-view-main">
      <div className="pw-bunit-detailed-header w-full flex flex-row justify-end gap-3 pr-2 mb-4 pl-5 pb-2">
        <div className="flex-1">
          <div className="pw-create-label">{t("Targets")}</div>
          <div className="flex flex-row items-center pw-border-bottom pb-2">
            <p className="text-sm text-neutral-600">
              {t("Emission Target Message")}
            </p>
          </div>
        </div>
        <div className="flex flex-row justify-between gap-2">
          {checkPermissions(["UPDATE_TARGET"], permissions) ? (
            <Button onClick={openEdit} className="pw-editbox-emission pt-2">
              <CreateIcon className="pw-bunit-edit-icon text-neutral-600" />
              <div className="pw-edit">Edit</div>
            </Button>
          ) : (
            ""
          )}
          {index > 0 && (
            <div
              onClick={() => onNavigateNext(-1)}
              className="pw-navigate-next pw-padding-5"
            >
              <img src="assets/icons/prev.svg" alt=" " />
            </div>
          )}
          {index < total_count - 1 && (
            <div
              onClick={() => onNavigateNext(1)}
              className="pw-navigate-next pw-padding-5"
            >
              <img src="assets/icons/next.svg" alt=" " />
            </div>
          )}
          <div
            onClick={() => onClose()}
            className=" flex justify-center items-center p-0 ml-0 w-8 h-7 rounded border border-neutral-300 "
          >
            <CloseIcon className="text-neutral-600" />
          </div>
        </div>
      </div>

      <div className="flex flex-col pw-detail-main-content gap-5 mb-3 m-5">
        <p className="text-sm text-neutral-900">
          <span className="text-neutral-600 mr-1">Facility :</span>{" "}
          {bunitData.name}
        </p>
        <p className="text-sm text-neutral-900 mt-1">
          <span className=" text-neutral-600 mr-1">Target coverage :</span>{" "}
          {baseLineValues[0]?.target_coverage}
        </p>
        <p className="text-sm text-neutral-900 mt-1">
          <span className="text-neutral-600 mr-1">Target alignment :</span>{" "}
          {baseLineValues[0]?.target_alignment}
        </p>
      </div>

      <div className="ml-5">
        <TabContext value={currentTab}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              width: "fit-content",
            }}
          >
            <TabList onChange={handleTabChange} className="pw-target-tabs">
              <Tab
                value="1"
                sx={{
                  fontWeight: currentTab == "1" ? "bold" : "regular",
                }}
                label="Emissions Target"
              />
              <Tab
                value="2"
                sx={{
                  fontWeight: currentTab == "2" ? "bold" : "regular",
                }}
                label="Metrics"
              />
            </TabList>
          </Box>
          <TabPanel value="1"></TabPanel>
          <TabPanel value="2"></TabPanel>
        </TabContext>
      </div>

      {!showMetrics ? (
        <div className="flex flex-col gap-10 ml-5 mr-5 -mt-5">
          <div>
            <Card>
              <TableContainer>
                <Table size="small" className="pw-activity-table">
                  {baseLineValues[0]?.target_coverage ===
                  "Common Target for total Scope 1, 2 & 3 emissions"
                    ? renderBaselineTable(1)
                    : baseLineValues[0]?.target_coverage ===
                      "Common Target for Scope 1 & 2; Separate Target for Scope 3"
                    ? renderBaselineTable(2)
                    : renderBaselineTable(3)}
                  <TableHead className="pw-activity-table-head">
                    <TableRow>
                      {cellColumnsRecentYear.map((eachCell, index) => (
                        <TableCell
                          key={index}
                          className={`pw-activity-list ${
                            index === 0
                              ? "pw-zero-row-target"
                              : index === 1
                              ? "pw-first-row-target"
                              : index === 2
                              ? " w-12"
                              : "pw-last-row-target"
                          }`}
                          align={index === 1 ? "center" : "left"}
                        >
                          {t(eachCell)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableCell>
                      <div className="flex flex-row justify-between">
                        {mostRecentYearValues[0]?.target_year}
                        <div>
                          <button
                            className={`text-info-500 ${
                              !mostRecentYearValues[0]?.target_year
                                ? "cursor-not-allowed"
                                : "cursor-pointer"
                            }`}
                            onClick={() => {
                              handleOpenDialog();
                              setEmissionYear(
                                mostRecentYearValues[0]?.target_year
                              );
                              setEmissionData(
                                mostRecentYearValues[0]?.emissions
                              );
                              setTargetType(TARGET_TYPES.MOST_RECENT);
                            }}
                            disabled={!mostRecentYearValues[0]?.target_year}
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      {mostRecentYearValues[0]?.target_value}
                    </TableCell>
                    <TableCell align="center">
                      <img
                        className="ml-3.5"
                        src="assets/icons/FileUpload.svg"
                        onClick={
                          mostRecentYearValues[0]?.target_attachments
                            ? () =>
                                handleTableCellClick(
                                  mostRecentYearValues[0]?.target_attachments
                                    .files || []
                                )
                            : undefined
                        }
                        alt="Upload"
                      />
                      {mostRecentYearValues[0]?.target_attachments?.files
                        ?.length > 0 && (
                        <sup className="text-xs bg-primary badge">
                          {
                            mostRecentYearValues[0].target_attachments?.files
                              ?.length
                          }
                        </sup>
                      )}
                    </TableCell>

                    <Dialog
                      open={showFileUpload}
                      onClose={handleClose}
                      className="pw-attachment-dialog"
                    >
                      <div>
                        <div
                          onClick={handleClose}
                          style={{
                            cursor: "pointer",
                            textAlign: "right",
                            padding: "10px",
                          }}
                        >
                          <CancelIcon />
                        </div>
                        <FileAttachmentsDetails
                          formData={attachmentsData}
                          // setFormData={(updatedFormData: any) =>
                          //   handleFileUpload(updatedFormData.attachments)
                          // }
                        />
                      </div>
                    </Dialog>
                    <TableCell>
                      {mostRecentYearValues[0]?.target_comments}
                    </TableCell>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </div>

          <div>
            <Card>
              {baseLineValues[0]?.target_coverage ===
              "Common Target for total Scope 1, 2 & 3 emissions"
                ? renderTargetTable(1)
                : baseLineValues[0]?.target_coverage ===
                  "Common Target for Scope 1 & 2; Separate Target for Scope 3"
                ? renderTargetTable(2)
                : renderTargetTable(3)}
            </Card>
          </div>

          <div>
            <Card>
              <Table size="small" className="pw-activity-table">
                <TableHead className="pw-activity-table-head">
                  <TableRow>
                    {cellColumnsNetZeroYear.map((eachCell, index) => (
                      <TableCell
                        key={index}
                        className={`pw-activity-list ${
                          index === 0
                            ? "w-44"
                            : index === 1
                            ? "w-32"
                            : index === 2
                            ? "w-40"
                            : index === 3
                            ? "w-12"
                            : index === 4
                            ? "w-52"
                            : "w-20"
                        }`}
                        align={index === 1 || index === 2 ? "center" : "left"}
                      >
                        {t(eachCell)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{netZeroValues[0]?.target_year}</TableCell>
                    <TableCell align="right">
                      {netZeroValues[0]?.target_value}
                    </TableCell>
                    <TableCell align="right">{100}</TableCell>
                    <TableCell
                      className={`${
                        netZeroValues.target_year
                          ? "cursor-pointer"
                          : "cursor-not-allowed"
                      }`}
                    >
                      <img
                        className="ml-2.5"
                        src="assets/icons/FileUpload.svg"
                        onClick={
                          netZeroValues[0]?.target_attachments
                            ? () =>
                                handleTableCellClick(
                                  netZeroValues[0]?.target_attachments.files ||
                                    []
                                )
                            : undefined
                        }
                        alt="Upload"
                      />
                      {netZeroValues[0]?.target_attachments &&
                      netZeroValues[0].target_attachments?.files?.length > 0 ? (
                        <sup className=" text-xs bg-primary badge">
                          {netZeroValues[0].target_attachments?.files?.length}
                        </sup>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell>{netZeroValues[0]?.target_comments}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Card>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-10 ml-5 mr-5 -mt-5">
          <div>
            <Card>
              {baseLineValues[0]?.target_coverage ===
              "Common Target for total Scope 1, 2 & 3 emissions"
                ? renderBaselineMetricTable(1)
                : baseLineValues[0]?.target_coverage ===
                  "Common Target for Scope 1 & 2; Separate Target for Scope 3"
                ? renderBaselineMetricTable(2)
                : renderBaselineMetricTable(3)}
            </Card>
          </div>
          <div>
            <Card>
              {baseLineValues[0]?.target_coverage ===
              "Common Target for total Scope 1, 2 & 3 emissions"
                ? renderTargetMetricTable(1)
                : baseLineValues[0]?.target_coverage ===
                  "Common Target for Scope 1 & 2; Separate Target for Scope 3"
                ? renderTargetMetricTable(2)
                : renderTargetMetricTable(3)}
            </Card>
          </div>
          <div>
            <Card>
              <Table size="small" className="pw-activitydata-table">
                <TableHead className="pw-activity-table-head bg-neutral-50">
                  <TableRow>
                    <TableCell className="pw-activity-list">
                      {t("Net zero year")}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className=" w-[205px]">
                      {netZeroValues[0]?.target_year}
                    </TableCell>
                    <TableCell className=" w-[550px]">0</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Card>
          </div>
        </div>
      )}

      {/* {versionHistoryData.length > 0 && (
        <TargetVersionHistory versionHistoryData={versionHistoryData} />
      )} */}

      {openDialog && (
        <EmissionDetailedViewDialog
          open={openDialog}
          onClose={handleDialogClose}
          year={emissionYear}
          emissionData={emissionData}
          targetScope={targetScope}
          targetCoverage={baseLineValues[0]?.target_coverage}
          targetType={targetType}
          categoryList={categoryList}
          handleTableCellClick={handleTableCellClick}
        ></EmissionDetailedViewDialog>
      )}
      {openCategoryDialog && (
        <CategoryDetailedViewDialog
          open={openCategoryDialog}
          onClose={handleDialogClose}
          year={emissionYear}
          emissionData={emissionData}
          baseLineValues={baseLineValues}
          targetValues={targetYearValues}
          categoryList={categoryList}
          categories={categories}
          targetScope={scopeToDisplay}
          targetType={categoryTargetType}
          handleTableCellClick={handleTableCellClick}
        ></CategoryDetailedViewDialog>
      )}
    </div>
  );
};

export default TargetDetailedView;
